import { render, staticRenderFns } from "./MachineItemsImageWrapper.vue?vue&type=template&id=dca32f48"
import script from "./MachineItemsImageWrapper.vue?vue&type=script&lang=js"
export * from "./MachineItemsImageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports